function getPrimaryCategoryFromUtag (key = 'product_category') {

	if (Array.isArray(window.utag_data[key])) {

		const [ primaryCategory ] = window.utag_data[key];
		return primaryCategory ?? '';

	}

	return '';

}

export default getPrimaryCategoryFromUtag;
